import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { container, heading2 } from 'app/livbrite/resources/theme/css'
import filterSvg from 'resources/svg/icons/filter.svg'

export const Wrapper = styled.div`
  padding-bottom: 50px;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  z-index: 1;
`

export const Container = styled.div`
  ${container}

  h1 {
    ${heading2}
    color: ${props => props.theme.palette.primary.alphaDark};
    display: inline-block;
  }
`

export const Sidebar = styled.div`
  flex-basis: 20%;
  padding-right: 30px;
  min-width: 288px;
  box-sizing: border-box;

  h3 {
    font: ${font('default', 'medium', '18px')};
    text-transform: uppercase;
    color: ${props => props.theme.palette.primary.alphaDark};
    margin-top: 35px;
  }
`

export const ContentWrapper = styled.div`
  flex-basis: 70%;
  ${props => bp('sm')`
    flex-basis: 100%;
    max-width: 100%;

    h2 {
      border-top: 1px solid ${props.theme.palette.general.greyMutted};
      padding-top: 20px;
      margin-top: 5px;
    }
  `}

  .toolbar {
    > div {
      padding: 12px 0;
      border-bottom: 1px solid ${props => props.theme.palette.general.greyMutted};

      button {
        display: flex;
        align-items: center;
        border: 1px solid ${props => props.theme.palette.general.strong};
        border-radius: 4px;
        background: ${props => props.theme.palette.general.light};
        padding: 2px 6px;
        font: ${font('default', 'bold', '14px/1')};
        margin-right: 20px;
        ${bp('sm', 'min-width')`
          display: none;
        `}

        &::before {
          content: '';
          display: inline-block;
          width: 15px;
          height: 16px;
          margin-right: 10px;
          background: url(${filterSvg}) no-repeat center;
        }
      }
    }
  }
`

export const DescriptionWrapper = styled.div`
  width: 75%;
  max-width: 720px;
  margin: 20px auto;
  font: ${font('default', 'light', '14px/1.5')};
  color: ${props => props.theme.palette.primary.alphaDark};
`

export const CategoryBlock = styled.div`
  padding-top: 30px;

  img {
    width: 100%;
  }
`

export const BannerWrapper = styled.div`
  background-color: ${props => props.theme.palette.primary.beta};
  margin: 20px auto;
  padding: 24px 40px;

  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    color: ${props => props.theme.palette.primary.alphaDark};

    > div {
      ${bp('sm')`
        margin-bottom: 15px;
      `}
    }
  }

  h2 {
    margin: 0 0 5px;
    font: ${font('default', 'bold', '32px/1')};
    letter-spacing: 1px;
    ${bp('sm')`
      margin-bottom: 15px;
    `}
  }

  p {
    margin: 0;
    text-transform: uppercase;
    font: ${font('default', 'bold', '16px/1')};
  }

  a {
    ${props => props.theme.css.buttonPrimary};
    background-color: ${props => props.theme.palette.general.light};
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'bold', '16px/1')};
    text-transform: uppercase;

    > img {
      max-width: 100%;
    }
  }
`
